import { Link } from "react-router-dom";
import PageHead from "@/app/PageHead";

interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export default function LegalPage({ title, description, children }: Props) {
  return (
    <article className="prose dark:prose-invert max-w-none">
      <PageHead title={title} description={description ?? title} />
      <p className="text-sm text-slate-500 not-prose">
        <Link to="/" className="hover:underline">
          ← Home
        </Link>
      </p>
      <h1>{title}</h1>
      {children}
    </article>
  );
}
